/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/
import React, { useState } from 'react';
import { Box, Grid, Typography, Button, Alert } from '@mui/material'
import { getFunctions, httpsCallable } from "firebase/functions";
import CircularProgress from '@mui/material/CircularProgress';
import { TextField } from 'formik-mui'
import { makeStyles } from 'tss-react/mui';
import MainCard from '../../../ui-elements/cards/MainCard';

import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { useNavigate } from 'react-router-dom';

const RegisterPage = () => { 
    const [error, setError] = useState('');
    const navigate = useNavigate()
    const { classes } = useStyles();
    const [loading, setLoading] = useState(false)

    const handleRegister = async (user, { setSubmitting, isValid }) => {
        try {
            const { email, password, displayName } = user;

            setError(null); // Reset error state
            setLoading(true);
            if (!email ||  !password || !displayName) {
                // The form is not valid, do not proceed with registration
                setSubmitting(false);
                setLoading(false);
                return;
            }
            const functions = getFunctions();
            const callableReturnMessage = httpsCallable(functions, 'createAdminUser');

            callableReturnMessage({ email, password, displayName }).then((response) => {
                console.log('response',response)
                navigate('/login');
                setError("")

            }).catch((error) => {
                console.log(error);
                setSubmitting(false);
                setLoading(false);
                setError("Invalid data, please make sure to enter correct data.")

            });
 
            // Redirect or show success message
        } catch (error) {
            console.error('Error registering user:', error.message);
            setError(error.message);
        }
    };


    return (
        <Box m={6}>

            <Grid container  >
                <Grid item xs={12} sm={1} md={1} />

                <Grid item xs={12} sm={10} md={10}>
                    <MainCard>

                        <Grid container   >
                            <Grid item xs={12} sm={12} md={3} />
                            <Grid item xs={12} sm={12} md={6} >
                                <Box m={2}   >

                                    <Grid container >

                                        <Grid item xs={12} sm={12} md={12}>
                                            {error && <Alert variant="filled" color='error'>{error}</Alert>}
                                            <Formik
                                                initialValues={{
                                                    email: '',
                                                    password: '',
                                                }}

                                                validationSchema={Yup.object().shape({
                                                    email: Yup.string().email().required('Email is required.'),
                                                    password: Yup.string().min(8).max(30).required('Password is required.'),
                                                    confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match.').required('Confirm password is required.'),
                                                    displayName: Yup.string().required('Display name is required.'),
                                                })}
                                                onSubmit={(
                                                    { email, password, confirmPassword, displayName },
                                                    { setSubmitting  }
                                                ) => {
                                                    handleRegister({ email, password, confirmPassword, displayName }, { setSubmitting  });
                                                }}
                                            >
                                                {() => (
                                                    <Form>

                                                        <Field
                                                            name="email"
                                                            label="email"
                                                            type="email"
                                                            component={TextField}
                                                            margin="normal"
                                                            variant="outlined"
                                                            fullWidth
                                                        />


                                                        <Field
                                                            name="password"
                                                            label="Password"
                                                            type="password"
                                                            component={TextField}
                                                            margin="normal"
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                        <Field
                                                            name="confirmPassword"
                                                            label="Confirm Password"
                                                            type="password"
                                                            component={TextField}
                                                            margin="normal"
                                                            variant="outlined"
                                                            fullWidth
                                                        /><Field
                                                            name="displayName"
                                                            label="Display Name"
                                                            type="text"
                                                            component={TextField}
                                                            margin="normal"
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                        <Grid container spacing={6} style={{ marginTop: '20px' }}>
                                                            <Grid item xs={12} sm={12} md={12}>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    size='large'
                                                                    type="submit"
                                                                    className={classes.button}
                                                                >
                                                                    {loading && <CircularProgress className={classes.progress} color="success" size={24} />}
                                                                    <Typography variant='h3' color="white"> Register</Typography>

                                                                </Button>
                                                                <span>{'  '}</span>
                                                                <Button
                                                                    className={classes.button} onClick={() => { navigate("/login") }}  >
                                                                    <Typography variant='h4'>  Log In</Typography>
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </Form>

                                                )}

                                            </Formik>


                                        </Grid>

                                    </Grid>

                                </Box>

                            </Grid>
                        </Grid>
                    </MainCard>

                </Grid>

            </Grid>
            <Grid item xs={12} sm={1} md={1} />

        </Box>
    );
};
const useStyles = makeStyles({ "name": { RegisterPage } })(theme => ({
    heroContent: {
        height: 'calc( 100vh - 150px)',
    },

    button: {
        margin: theme.spacing(1),
        color: "white"
    },

    floatingLabelFocusStyle: {
        color: theme.palette.primary.main
    },
    ImgLoginDescp: {
        width: '300px',
        margin: 'auto',
        marginLeft: "auto",
        marginRight: 'auto'
    },
    containerBox: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: '10px',
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat'
    },
    BoxContainerLogin: {
        padding: '1em',
        borderRadius: '10px',
        boxShadow: 'rgb(38 127 161) 1px 5px 24px 0px',

    }
}))


export default RegisterPage;
